import { z } from 'zod'

/** 必填正整数（含上下界） */
export function positiveIntSchema(label: string, min: number, max: number) {
  return z.preprocess(
    (v) => (v === null || v === undefined || v === '' ? undefined : Number(v)),
    z
      .number({ message: `请输入${label}` })
      .refine((n) => !Number.isNaN(n), `${label}须为有效数字`)
      .refine((n) => Number.isInteger(n), `${label}须为整数`)
      .min(min, `范围为 ${min}～${max}`)
      .max(max, `范围为 ${min}～${max}`),
  )
}

/** 可选正整数（空值跳过；有值则校验范围） */
export function optionalPositiveIntSchema(min: number, max: number) {
  return z.preprocess(
    (v) => (v === null || v === undefined || v === '' ? undefined : Number(v)),
    z
      .union([z.undefined(), z.number()])
      .refine((n) => n === undefined || !Number.isNaN(n), '须为有效数字')
      .refine((n) => n === undefined || Number.isInteger(n), '须为整数')
      .refine((n) => n === undefined || (n >= min && n <= max), `范围为 ${min}～${max}`),
  )
}

export const longitudeSchema = z.preprocess(
  (v) => (v === null || v === undefined || v === '' ? undefined : Number(v)),
  z
    .number({ message: '请输入经度' })
    .refine((n) => !Number.isNaN(n), '经度须为有效数字')
    .min(-180, '经度须在 −180～180 之间（WGS-84）')
    .max(180, '经度须在 −180～180 之间（WGS-84）'),
)

export const latitudeSchema = z.preprocess(
  (v) => (v === null || v === undefined || v === '' ? undefined : Number(v)),
  z
    .number({ message: '请输入纬度' })
    .refine((n) => !Number.isNaN(n), '纬度须为有效数字')
    .min(-90, '纬度须在 −90～90 之间（WGS-84）')
    .max(90, '纬度须在 −90～90 之间（WGS-84）'),
)

/** 中方员工数量等业务计数：≥1 的正整数 */
export const employeeCountSchema = positiveIntSchema('中方员工数量', 1, 999999)

/** 中方员工数量：可空，有值则须为 1～999999 的整数 */
export const optionalEmployeeCountSchema = optionalPositiveIntSchema(1, 999999)
